import React from 'react'
import { hasObject } from '@lib/helpers'

import Photo from '@components/photo'

const ProductTileThumbnail = ({ thumbnails = [], activeVariant }) => {
  const { options } = activeVariant

  const defaultThumbnails = thumbnails.find((set) => !set.forOption)
  const variantThumbnails = thumbnails.find((set) => {
    const option = set.forOption
      ? {
          name: set.forOption.split(':')[0],
          value: set.forOption.split(':')[1],
        }
      : {}
    return option.value && hasObject(options, option)
  })

  const photos = variantThumbnails ? variantThumbnails : defaultThumbnails

  return (
    <>
      <Photo photo={photos?.default} layout="fill" objectFit="cover" />

      {photos?.hover && photos?.hover.src && (
        <Photo
          photo={photos.hover}
          layout="fill"
          objectFit="cover"
          className="is-hover"
        />
      )}
    </>
  )
}

export default ProductTileThumbnail
